<template>
  <div class="addBrand">
    <div class="topBar">
      <div class="subTitle">部门管理
        
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px; margin-left:10px">
            添加部门
        </div>
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">账号:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="admin_user"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
               <el-row>
              <el-col :span="5">
                <div class="grid-content label">所属部门:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-select v-model="group" :data="options" placeholder="请选择">
                     <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                     </el-option>
                  </el-select>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">姓名:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="real_name"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">邮箱:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="emali"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">电话:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="mobile"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">登录密码:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="password"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
               </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">确认密码:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="new_pass"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">备注信息:</div>
              </el-col>
              
               <el-col :span="16" >
                <div class="grid-content input">
                  <textarea name="" cols="30" rows="10" placeholder="请输入内容" id="ipt"></textarea>
                </div>
               </el-col>
              
            </el-row>
          </div>
          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
        <div class="hint">
         <span style="color:#F64E62">*</span>
         <span class="hint_sapn">为必填项</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "addBrand",
  data() {
    return {
            serve: this.$store.state.serve,
       admin_user: "",
       real_name: "",
       mobile: "",
       emali: "",
       password:"",
       new_pass:"",
       group:"",
      //  show: 1
       options: [],
        value:'',
    };
  },
  created() {
     const that=this;
     this.username = this.$cookies.get("username");
     this.token = this.$cookies.get("token")
     this.axios.get(this.serve+"/admin/get_admin_group",{
        params: {
           username:this.username,
           token: this.token,
        }
     }).then(res =>{
        that.options = res.data.data
        
     })
  },
  methods: {
    submit() { 
      if (this.admin_user == "") {
        this.$message.error("账号不能为空");
        return;
      }
      if (this.group == "") {
        this.$message.error("未选择所属部门");
        return;
      }
       if (this.real_name == "") {
        this.$message.error("姓名不能为空");
        return;
      }
      if (this.email == "") {
        this.$message.error("邮箱不能为空");
        return;
      }
     if (this.mobile == "") {
        this.$message.error("电话不能为空");
        return;
      }
      if (this.password == "") {
        this.$message.error("密码不能为空");
        return;
      }
      if (this.new_pass == "") {
        this.$message.error("确认密码不能为空");
        return;
      }
      if(this.password !== this.new_pass){
         this.$message.error('两次输入密码不一致')
         return
      }
      let formData = new FormData();
      formData.append("username",this.username);
      formData.append("token" , this.token);
      formData.append("admin_user", this.admin_user);
      formData.append("real_name", this.real_name);
      formData.append("mobile", this.mobile);
      formData.append("email", this.email);
      formData.append("password", this.password);
      formData.append("new_pass", this.new_pass);
      formData.append("group", this.group);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.axios
        .get(this.serve+"/admin/create_admin_user", formData, config)
        .then( res=> {
          if (res.status === 200) {
            loading.close();
            // that.$router.push({ path: "./brand" });
          }
        })
        .catch(function(err) {
          alert("操作失败");
        });
    }
  }
};
</script>
<style lang="scss">
.addBrand {
  background: #f5f5f5;
  color: #333;
  height: 1000px;
   #ipt{
      width: 282px;
      height: 180px;
      border:1px solid rgba(221, 221, 221, 1);
      color: #606266;
      // outline: none;
      border-radius: 4px;
      outline-color:  #24715d;
      // outline: 1px solid #24715d;
   }
   .hint{
         font-size:14px;
         font-family:"MicrosoftYaHeiLight";
         font-weight:300;
         color:#606266;
         position: absolute;
         top:71px;
         right:40px;
   }
  .button{
     margin: 0 auto;
  }

  .form-title {
    line-height: 46px;
    height: 46px;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }

  .input {
    width: 100%;
    display: flex;
    align-items: baseline;
  }
  textarea {
    height: 300px;
    width: 342px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
    position: relative;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
    margin-top: 16px;
  }
  .button {
    border-radius: 5px;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .el-row {
    margin-bottom: 30px;
  }

  .switch {
    display: flex;
  }
  .el-switch {
    margin: 0 0 30px 26px;
  }
}
</style>